import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import ProductListResults from 'components/Products/ProductListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  products: state.products,
  productCategories: state.categories.productCategories,
  productCompanies: state.categories.productCompanies,
  idGen: state.idGen
});

const ProductList = (props) => (
  <>
    <Helmet>
      <title>Products | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <ProductListResults
          activeUserId={props.activeUserId}
          activeUserType={props.activeUserType}
          products={props.products}
          productCategories={props.productCategories}
          productCompanies={props.productCompanies}
          idGen={props.idGen}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (ProductList);